import type { PropsWithChildren } from "react";
import type { IContentContext } from "../contexts";
import { ContentContext } from "../contexts";
import type { PageMeta } from "@op/puck-types";

export const defaultPageMeta: PageMeta = {
  id: "",
  organizationName: "",
  organizationSlug: "",
  projectName: "",
  projectSlug: "",
  languageKey: "",
  topicName: "",
  topicSlug: "",
  name: "",
  slug: "",
  metaTitle: null,
  metaDescription: null,
  metaImage: null,
  analyticsEnabled: false,
  indexed: false,
  currentVersionId: "",
  readingSettings: {
    noContainer: false,
    excursionsInOutline: false,
  },
  publishedAt: null,
};

export interface ContentProviderProps
  extends Partial<IContentContext>, PropsWithChildren {}

export const ContentProvider = ({
  children,
  outline = {
    content: [],
    excursions: {},
  },
  citations = {
    content: [],
    excursions: {},
  },
  figures = {
    content: [],
    excursions: {},
  },
  glossaryItems = [],
  excursions = [],
  versions = [],
  pdfUrl,
  meta = defaultPageMeta,
}: ContentProviderProps) => {
  return (
    <ContentContext.Provider
      value={{
        outline,
        citations,
        figures,
        glossaryItems,
        excursions,
        versions,
        meta,
        pdfUrl,
      }}
    >
      {children}
    </ContentContext.Provider>
  );
};
